import { shadeColor } from "../../../../../helpers/shade-color";

const BACKGROUND = {
  light: {
    accent: "#F8F8F8",
    text: "#171717",
  },
  dark: {
    accent: "#2A2A2A",
    text: "#FAFAFA",
  },
};

const shadeAmount = {
  light: 60,
  dark: -60,
};

export const createDexColor = ({ color, mode = "light" }) => {
  const { id, accent, text } = color;

  const first = BACKGROUND[mode];

  const second = { accent, text };
  const third = {
    accent: shadeColor(accent, shadeAmount[mode]),
    text,
  };

  return { id, first, second, third, type: "custom" };
};
